import React from 'react';
import PropTypes from 'prop-types';
import { PromoStrip } from 'dw-contentful-components';
import { RichText } from '../RichText';
import '../../styles/PromoStripWrapper.scss';

const props = {
  brand: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

const PromoStripWrapper = ({ brand, data }) => {
  const { backgroundColour, contentText, link, leftSideMedia, rightSideMedia } = data;
  const url = link?.url;
  const linkText = link?.text;
  const leftSideMediaUrl = leftSideMedia?.asset?.file?.url;
  const rightSideMediaUrl = rightSideMedia?.asset?.file?.url;
  const leftSideMediaFileName = leftSideMedia?.asset?.file?.fileName;
  const rightSideMediaFileName = rightSideMedia?.asset?.file?.fileName;
  const content = <RichText content={contentText} />;

  return (
    <div
      data-testid="promo-strip-wrapper"
      className={`${brand} promo-strip-wrapper`}
    >
      <PromoStrip
        content={content}
        url={url}
        linkText={linkText}
        backgroundColour={backgroundColour}
        leftSideMediaUrl={leftSideMediaUrl}
        rightSideMediaUrl={rightSideMediaUrl}
        leftSideMediaFileName={leftSideMediaFileName}
        rightSideMediaFileName={rightSideMediaFileName}
      />
    </div>
  );
};

PromoStripWrapper.propTypes = props;

export { PromoStripWrapper };
